import { queryOptions } from '@tanstack/react-query'
import branditRails from '../api/brandit_rails'

export const featureFlagKeys = {
  all: ['featureFlags'] as const,
  detail: (portalId: number, identityKey: string, flagKey: string) =>
    [...featureFlagKeys.all, portalId, identityKey, flagKey] as const,
  navigation: (portalId: number, identityKey: string, flagKey: string, visit: string) =>
    [...featureFlagKeys.detail(portalId, identityKey, flagKey), 'navigation', visit] as const,
  checkout: (portalId: number, identityKey: string, flagKey: string, flow: number) =>
    [...featureFlagKeys.detail(portalId, identityKey, flagKey), 'checkout', flow] as const
}

export const featureFlagQueryOptions = (queryKey: readonly (string | number)[], flagKey: string) =>
  queryOptions({
    queryKey,
    queryFn: async () => {
      const { data } = await branditRails.get<{ enabled: boolean }>(`/feature_flags/${encodeURIComponent(flagKey)}`)
      return data.enabled
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
